import { Box, Card, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { IntelSearchGuideline } from "./types/IntelSearchGuideline";

export default function SearchGuidelinesTable({ guideline }: { guideline: IntelSearchGuideline }) {
  return (
    <Box>
      <Typography variant="h5" marginTop={3} marginBottom={2}>
        {guideline.underwriter.name}
      </Typography>
      <Card>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell width="42%">Purchase</TableCell>
              <TableCell width="42%">Refinance</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <Typography variant="subtitle2">Full Search</Typography>
              </TableCell>
              <TableCell sx={{ whiteSpace: "pre-line" }}>{guideline.purchaseFullSearch}</TableCell>
              <TableCell sx={{ whiteSpace: "pre-line" }}>{guideline.refinanceFullSearch}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant="subtitle2">Prior OP</Typography>
              </TableCell>
              <TableCell sx={{ whiteSpace: "pre-line" }}>{guideline.purchasePriorOP}</TableCell>
              <TableCell sx={{ whiteSpace: "pre-line" }}>{guideline.refinancePriorOP}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant="subtitle2">Prior LP</Typography>
              </TableCell>
              <TableCell sx={{ whiteSpace: "pre-line" }}>{guideline.purchasePriorLP}</TableCell>
              <TableCell sx={{ whiteSpace: "pre-line" }}>{guideline.refinancePriorLP}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Card>
    </Box>
  );
}
